// extracted by mini-css-extract-plugin
export default {"input":"NumberInput_input__Gcq-K","truncate":"NumberInput_truncate__kCZ1f","focused":"NumberInput_focused__e346x"};